import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import messages from "../../redux/messages";
import { useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  // ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  // Dropdown,
  Breadcrumb,
  // ListGroup,
  // InputGroup,
  Table,
  // Nav,
  Tabs,
  Tab,
  ButtonGroup,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
// import toastr from "toastr";

//Tabla, Navbar y Sidebar
// import CustomTable from "../../components/CustomTable";
// import CustomPagint from "../../components/CustomPagint";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarCapacitacion from "../../components/SidebarDashboard";

//redux
import {
  // deleteDetailTraining,
  editDetailTraining,
  getDetailTraining,
  // saveDetailTraining,
} from "../../redux/capacitacionDesarrollo/DetailTraining/actions";

import { getEmployeeMonitorEvents } from "../../redux/capacitacionDesarrollo/EmployeeMonitor/actions";
import { getAreas, getCarpetas } from "../../redux/gestorDocumental/actions";
import config from "../../config";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import LinkDescargaListGD from "../../components/gestorDocumental/LinkDescargaListGD";
import LinkDescargaGD from "../../components/gestorDocumental/LinkDescargaGD";
import CustomPagint from "../../components/CustomPagint";

const DetailTrainingMonitor = (props) => {
  const filters = [
    { id: "evento", desc: "Evento" },
    // { id: "codigo", desc: "Código" },
    { id: "responsable", desc: "Responsable" },
    { id: "estado", desc: "Estado" },
  ];

  const schema = Yup.object().shape({
    calificacion: Yup.string().ensure().required("**Campo requerido"),
    // archivo: Yup.string().ensure().required("**Campo requerido"),
    archivo: Yup.string().when("edit", {
      is: () => !edit || (edit && !editItem.archivo_id),
      then: Yup.string().required("**Campo requerido"),
    }),
  });
  //Variables hooks
  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");
  const [tipoBusqueda, setTipoBusqueda] = useState(filters[0]);

  //Variables redux
  const {
    loaderDetailTraining,
    detailTraining,
    detailTrainingFail,
    saveLoaderDetailTraining,
    detailTrainingFormError,
  } = useSelector((store) => store.detailTraining);
  const pages = Math.ceil(detailTraining ? detailTraining.count / limit : 0);
/*   const {
    // loaderEmployeeMonitor,
    employeeMonitor,
    // employeeMonitorFalla,
    // employeeMonitorFormError,
  } = useSelector((store) => store.employeeMonitorCapacitation); */
  const { areas, carpetas } = useSelector((store) => store.gestorDocumental);
  const { carpeta, tipoDocumentoGD, descripcion } =
    config.gestorDocumental.capacitacion;
  const { area, email } = config.gestorDocumental;
  const userType = useSelector((store) => store.auth.userType);
  const userId = useSelector((store) => store.auth.id);
  const userRoles = useSelector((store) => store.auth.userRoles);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    _getDetailTraining();
    //dispatch(getAreas());
    //dispatch(getCarpetas());
  }, []);

  // useEffect(() => {
  //  dispatch(getEmployeeMonitorEvents());
  // }, []);

  //methods
  const _getDetailTraining = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getDetailTraining({
        offset: offs,
        limit: lim,
        // tipo_busqueda: "",
        filter: parseInt(props.match.params.id),
        campania_id: parseInt(props.match.params.idCampania),
        filter_2:
          filt !== ""
            ? JSON.stringify({
                nombre_evento_capacitacion__icontains:
                  tipoBusqueda.id === "evento" ? filt : undefined,
                campania__codigo_campania:
                  tipoBusqueda.id === "codigo" ? filt : undefined,
                responsable__nombre__icontains:
                  tipoBusqueda.id === "responsable" ? filt : undefined,
                capacitacion_asistencia__estado__descripcion__icontains:
                  tipoBusqueda.id === "estado" ? filt : undefined,
              })
            : undefined,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDetailTraining(oOffset, limit, oSearch);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDetailTraining(oOffset, limit, e.target.filter.value);
  };

  // const onSearchState = (e) => {
  //   e.preventDefault();
  //   // if (!e.currentTarget.value.trim()) {
  //   //   return;
  //   // }
  //   setFilter(e.currentTarget.value);
  //   const oOffset = 0;
  //   setOffset(oOffset);
  //   setCurrentPage(1);
  //   _getDetailTraining(oOffset, limit, e.currentTarget.value);
  // };

  const onSubmit = async (req) => {
    const empresaT = editItem.list_empleado[0].empresa[0];
    const oArea = areas.find(
      (item) => item.descripcion.toLowerCase() === area.toLowerCase()
    );
    const oCarpeta = carpetas.find(
      (item) => item.descripcion.toLowerCase() === carpeta.toLowerCase()
    );

    var capacitacionMon = new FormData();
    const exist = document.getElementById("archivo").files.length > 0;
    if (exist) {
      const filebase64 = await getBase64(
        document.getElementById("archivo").files[0]
      );
      const fileName = document.getElementById("archivo").files[0].name;
      const fName = String(fileName)
        .substring(0, String(fileName).lastIndexOf("."))
        .replace(/\W/g, "");
      const fExt = `.${String(fileName).substr(
        fileName.lastIndexOf(".") + 1 - fileName.length
      )}`;
      const aFileBase = String(filebase64).split(",");

      capacitacionMon.append(
        "codigo_empleado",
        editItem.list_empleado[0].codigo
      );
      capacitacionMon.append("tipo_documento", tipoDocumentoGD);
      capacitacionMon.append("archivo", aFileBase[1]);
      capacitacionMon.append("contentTypeGD", `${aFileBase[0]},`);
      capacitacionMon.append("origen", fName + fExt);
      capacitacionMon.append("nombre", fName);
      capacitacionMon.append("extension", fExt);
      // capacitacionMon.append("tipo_documento_GD", tipoDocumentoGD);
      capacitacionMon.append("descripcion", descripcion);
      capacitacionMon.append("fecha", moment().format("YYYY-MM-DD"));
      capacitacionMon.append("id_area", oArea.id);
      capacitacionMon.append("id_carpeta_encabezado", oCarpeta.id);
      capacitacionMon.append("empresa", empresaT);
      capacitacionMon.append(
        "division",
        editItem.list_empleado[0].Division_Personal_List[0].descripcion
      );
    }
    // evaluationMon.append("id_registro", parseInt(editItem.id));

    // const exist = document.getElementById("archivo").files.length > 0;
    // const _editItem = editItem;
    // _editItem.tipo_plan_accion = req.tipo_plan_accion;
    req.archivo = editItem.archivo;
    req.id = editItem.capacitacion_asistencia_id;
    req.nota_evaluacion = req.calificacion;
    dispatch(
      editDetailTraining(
        req,
        editItem.detalle_evento[0].id,
        parseInt(props.match.params.id),
        index,
        setShowFormModal,
        editItem.archivo,
        capacitacionMon,
        exist
      )
    );
    // }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarCapacitacion show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mb-4 px-2">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() => history.goBack()}
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  // onClick={() =>
                  //   history.push(`/descriptores-perfiles/menu-usuario`)
                  // }
                  className="text-uppercase"
                  onClick={() => history.goBack()}
                >
                  MONITOR COLABORADORES
                </Breadcrumb.Item>
                <Breadcrumb.Item active title className="text-uppercase">
                  {/* {props.match.params.nombre} */}
                  EVENTOS DE CAPACITACION
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </div>
          <div className="px-2">
            <hr />
          </div>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">
              {props.match.params.nombre}
            </h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  {/* {tipoBusqueda.id === "estado" ? (
                    <Form.Control
                      as="select"
                      name="filter"
                      id="filter"
                      placeholder="Buscar"
                      className="rounded-pill form-control-sm"
                      onChange={onSearchState}
                      style={{ minWidth: "174px" }}
                    >
                      <option
                        className="text-muted"
                        key={0}
                        value=""
                        //  selected
                        //  disabled
                      ></option>
                      <option key={1} value="True">
                        Abierto
                      </option>
                      <option key={1} value="False">
                        Cerrado
                      </option>
                    </Form.Control>
                  ) : ( */}
                  <Form.Control
                    name="filter"
                    id="filter"
                    defaultValue={filter}
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="filter"
                  ></Form.Control>
                  {/* )} */}
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {userRoles.length > 0 && userRoles.includes("empleado") ? (
            <Col md="6">
              <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                <h5 className="text-black-50 m-0 text-uppercase">
                  Plan de desarrollo{" "}
                  <Button
                    className="rounded-pill"
                    variant="primary"
                    onClick={() =>
                      history.push(`/empleado-docs/${userId}/:${userType}`)
                    }
                  >
                    Subir documentos
                  </Button>
                </h5>
              </div>
            </Col>
          ) : null}
          {!!detailTrainingFail && (
            <Alert variant="danger" className="mt-4 mb-1 mx-2">
              {detailTrainingFail}
            </Alert>
          )}
          {loaderDetailTraining ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : detailTraining != null && detailTraining.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  {/* <CustomTable columns={columns} data={matrixNineBoxes.data} /> */}
                  <Table striped responsive>
                    <thead>
                      <tr>
                        <th>Código</th>
                        <th>Nombre</th>
                        <th>Fecha inicio</th>
                        <th>Duración horas</th>
                        <th>Responsable</th>
                        {/* {(userRoles.length > 0 && userRoles.includes("jefe")) ||
                        userRoles.includes("administrador") ? ( */}
                        <th>Calificación</th>
                        {/* ) : null} */}
                        <th>Estado</th>
                        {/* {(userRoles.length > 0 && userRoles.includes("jefe")) ||
                        userRoles.includes("administrador") ? ( */}
                        <th>Asistio</th>
                        {/* ) : null} */}

                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailTraining.data.map((item, index) => (
                        <tr key={item.id}>
                          <td>{item.codigo}</td>
                          <td>
                            {item.detalle_evento[0].nombre_evento_capacitacion}
                          </td>
                          <td>{item.fecha_inicio}</td>
                          <td>{item.duracion_horas}</td>
                          <td>{item.responsable}</td>
                          {/* {(userRoles.length > 0 &&
                            userRoles.includes("jefe")) ||
                          userRoles.includes("administrador") ? ( */}
                          <td>{item.calificacion}</td>
                          {/* ) : null} */}
                          <td>
                            <div
                              className={`p-2 rounded-pill ${
                                item.detalle_evento[0].list_estado[0]
                                  .descripcion
                                  ? "text-white"
                                  : ""
                              } text-center`}
                              style={{
                                backgroundColor: item.detalle_evento[0]
                                  .list_estado
                                  ? item.detalle_evento[0].list_estado[0].color
                                  : "",
                                minWidth: "90px",
                              }}
                            >
                              {item.detalle_evento[0].list_estado
                                ? item.detalle_evento[0].list_estado[0]
                                    .descripcion
                                : "Sin estado"}
                            </div>
                            {/* {item.estado} */}
                          </td>
                          {/* {(userRoles.length > 0 &&
                            userRoles.includes("jefe")) ||
                          userRoles.includes("administrador") ? ( */}
                          <td>
                            {item.asitio == true ? "Asistio" : "No asistio"}
                          </td>
                          {/* ) : null} */}
                          <td>
                            <div className="button-group d-flex" role="group">
                              <Button
                                size="sm"
                                variant="gray"
                                type="button"
                                onClick={() => onEdit(item, index)}
                              >
                                <i className="material-icons">list_alt</i>
                              </Button>
                              {!!item.detalle_evento &&
                              !!item.detalle_evento.length > 0 &&
                              item.detalle_evento[0].es_evaluacion === true ? (
                                <Button
                                  size="sm"
                                  variant="gray"
                                  type="button"
                                  onClick={() =>
                                    history.push(
                                      `/capacitacion-desarrollo/formato-evaluacion-capacitacion/${item.detalle_evento[0].id}/${item.list_empleado[0].id}`
                                    )
                                  }
                                >
                                  <i className="material-icons">assignment</i>
                                </Button>
                              ) : null}

                              {userRoles.length > 0 &&
                              (userRoles.includes("jefe") ||
                                userRoles.includes("administrador")) &&
                              item.archivo_id ? (
                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip {...props}>
                                      Ver documento subido
                                    </Tooltip>
                                  }
                                >
                                  <LinkDescargaListGD
                                    id={item.id}
                                    filters={{
                                      email: email,
                                      id: item.list_archivo[0].id_documento,
                                      llave: item.list_archivo[0].llave,
                                    }}
                                    origen={item.list_archivo[0].origen}
                                    icono={
                                      <i className="material-icons">file</i>
                                    }
                                    cType={item.list_archivo[0].contentTypeGD}
                                  />
                                </OverlayTrigger>
                              ) : null}

                              {/* <Button
                                size="sm"
                                // className="text-gray"
                                variant="gray"
                                type="button"
                                // onClick={() => onDelete(value.row.original.id, value.row.index)}
                              >
                                <i className="material-icons">military_tech</i>
                              </Button> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={detailTraining.count}
                pages={pages}
                pagFunc={_getDetailTraining}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4 mx-2">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal
          show={showFormModal}
          onHide={() => setShowFormModal(false)}
          size="lg"
        >
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              descripcion: edit
                ? editItem.detalle_evento[0].list_tipo_capacitacion[0]
                    .descripcion
                : "",
              nombre_capacitacion: edit
                ? editItem.detalle_evento[0].list_capacitacion[0]
                    .nombre_capacitacion
                : "",
              fecha_inicio: edit ? editItem.detalle_evento[0].fecha_inicio : "",
              fecha_fin: edit ? editItem.detalle_evento[0].fecha_fin : "",
              duracion_horas: edit
                ? editItem.detalle_evento[0].duracion_horas
                : "",
              facilitador: edit ? editItem.detalle_evento[0].facilitador : "",
              descripcion_formacion: edit
                ? editItem.detalle_evento[0].list_nivel_formacion[0].descripcion
                : "",
              formacion: edit
                ? editItem.detalle_evento[0].list_formacion[0].descripcion
                : "",
              titulo: edit
                ? editItem.detalle_evento[0].list_titulo[0].descripcion
                : "",
              especialidad: edit
                ? editItem.detalle_evento[0].list_especialidad[0].descripcion
                : "",
              modalidad: edit
                ? editItem.detalle_evento[0].list_modalidad[0].descripcion
                : "",
              enfoque: edit
                ? editItem.detalle_evento[0].list_enfoque[0].descripcion
                : "",
              calificacion: edit ? editItem.calificacion : "",
              archivo: "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Detalle capacitación" : "Detalle capacitación"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {detailTrainingFormError &&
                  typeof detailTrainingFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {detailTrainingFormError}
                    </Alert>
                  ) : null}

                  <Tabs
                    defaultActiveKey="detalle"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                  >
                    <Tab eventKey="detalle" title="Detalle capacitación">
                      <Row>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Tipo capacitación
                              </Form.Label>
                              <Form.Control
                                id="descripcion"
                                name="descripcion"
                                isInvalid={
                                  touched.descripcion && errors.descripcion
                                }
                                isValid={
                                  touched.descripcion && !errors.descripcion
                                }
                                onBlur={handleBlur("descripcion")}
                                // onChange={handleChange}
                                value={values.descripcion}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.descripcion && (
                                <div>
                                  <small className="text-danger">
                                    {errors.descripcion}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Capacitación/Curso
                              </Form.Label>
                              <Form.Control
                                id="nombre_capacitacion"
                                name="nombre_capacitacion"
                                isInvalid={
                                  touched.nombre_capacitacion &&
                                  errors.nombre_capacitacion
                                }
                                isValid={
                                  touched.nombre_capacitacion &&
                                  !errors.nombre_capacitacion
                                }
                                onBlur={handleBlur("nombre_capacitacion")}
                                //onChange={handleChange}
                                value={values.nombre_capacitacion}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.nombre_capacitacion && (
                                <div>
                                  <small className="text-danger">
                                    {errors.nombre_capacitacion}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Responsable
                              </Form.Label>
                              <Form.Control
                                id="facilitador"
                                name="facilitador"
                                isInvalid={
                                  touched.facilitador && errors.facilitador
                                }
                                isValid={
                                  touched.facilitador && !errors.facilitador
                                }
                                onBlur={handleBlur("descripcion")}
                                // onChange={handleChange}
                                value={values.facilitador}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.facilitador && (
                                <div>
                                  <small className="text-danger">
                                    {errors.facilitador}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">Enfoque</Form.Label>
                              <Form.Control
                                id="enfoque"
                                name="enfoque"
                                isInvalid={touched.enfoque && errors.enfoque}
                                isValid={touched.enfoque && !errors.enfoque}
                                onBlur={handleBlur("enfoque")}
                                // onChange={handleChange}
                                value={values.enfoque}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.enfoque && (
                                <div>
                                  <small className="text-danger">
                                    {errors.enfoque}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                      </Row>
                    </Tab>

                    <Tab eventKey="fecha" title="Fechas">
                      <Row>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Fecha inicio
                              </Form.Label>
                              <Form.Control
                                id="fecha_inicio"
                                name="fecha_inicio"
                                isInvalid={
                                  touched.fecha_inicio && errors.fecha_inicio
                                }
                                isValid={
                                  touched.fecha_inicio && !errors.fecha_inicio
                                }
                                onBlur={handleBlur("descripcion")}
                                // onChange={handleChange}
                                value={values.fecha_inicio}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.fecha_inicio && (
                                <div>
                                  <small className="text-danger">
                                    {errors.fecha_inicio}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Fecha fin
                              </Form.Label>
                              <Form.Control
                                id="fecha_fin"
                                name="fecha_fin"
                                isInvalid={
                                  touched.fecha_fin && errors.fecha_fin
                                }
                                isValid={touched.fecha_fin && !errors.fecha_fin}
                                onBlur={handleBlur("fecha_fin")}
                                // onChange={handleChange}
                                value={values.fecha_fin}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.fecha_fin && (
                                <div>
                                  <small className="text-danger">
                                    {errors.fecha_fin}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Horas de duración
                              </Form.Label>
                              <Form.Control
                                id="duracion_horas"
                                name="duracion_horas"
                                isInvalid={
                                  touched.duracion_horas &&
                                  errors.duracion_horas
                                }
                                isValid={
                                  touched.duracion_horas &&
                                  !errors.duracion_horas
                                }
                                onBlur={handleBlur("duracion_horas")}
                                // onChange={handleChange}
                                value={values.duracion_horas}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.duracion_horas && (
                                <div>
                                  <small className="text-danger">
                                    {errors.duracion_horas}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Modalidad
                              </Form.Label>
                              <Form.Control
                                id="modalidad"
                                name="modalidad"
                                isInvalid={
                                  touched.modalidad && errors.modalidad
                                }
                                isValid={touched.modalidad && !errors.modalidad}
                                onBlur={handleBlur("modalidad")}
                                // onChange={handleChange}
                                value={values.modalidad}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.modalidad && (
                                <div>
                                  <small className="text-danger">
                                    {errors.modalidad}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                      </Row>
                    </Tab>

                    <Tab eventKey="formacion" title="Formación académica">
                      <Row>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Nivel de formación
                              </Form.Label>
                              <Form.Control
                                id="descripcion_formacion"
                                name="descripcion_formacion"
                                isInvalid={
                                  touched.descripcion_formacion &&
                                  errors.descripcion_formacion
                                }
                                isValid={
                                  touched.descripcion_formacion &&
                                  !errors.descripcion_formacion
                                }
                                onBlur={handleBlur("descripcion_formacion")}
                                // onChange={handleChange}
                                value={values.descripcion_formacion}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.descripcion_formacion && (
                                <div>
                                  <small className="text-danger">
                                    {errors.descripcion_formacion}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>

                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">Título</Form.Label>
                              <Form.Control
                                id="titulo"
                                name="titulo"
                                isInvalid={touched.titulo && errors.titulo}
                                isValid={touched.titulo && !errors.titulo}
                                onBlur={handleBlur("titulo")}
                                // onChange={handleChange}
                                value={values.titulo}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.titulo && (
                                <div>
                                  <small className="text-danger">
                                    {errors.titulo}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                      </Row>

                      <Row>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Formación
                              </Form.Label>
                              <Form.Control
                                id="formacion"
                                name="formacion"
                                isInvalid={
                                  touched.formacion && errors.formacion
                                }
                                isValid={touched.formacion && !errors.formacion}
                                onBlur={handleBlur("formacion")}
                                // onChange={handleChange}
                                value={values.formacion}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.formacion && (
                                <div>
                                  <small className="text-danger">
                                    {errors.formacion}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                        <Form.Group as={Col}>
                          <Row className="align-items-end">
                            <Col sm={loaderDetailTraining ? "10" : "12"}>
                              <Form.Label className="ml-2">
                                Especialidad
                              </Form.Label>
                              <Form.Control
                                id="especialidad"
                                name="especialidad"
                                isInvalid={
                                  touched.especialidad && errors.especialidad
                                }
                                isValid={
                                  touched.especialidad && !errors.especialidad
                                }
                                onBlur={handleBlur("especialidad")}
                                // onChange={handleChange}
                                value={values.especialidad}
                                disabled
                                className="rounded-pill"
                                type="text"
                                // placeholder="Estado"
                              ></Form.Control>
                              {!!errors.especialidad && (
                                <div>
                                  <small className="text-danger">
                                    {errors.especialidad}
                                  </small>
                                </div>
                              )}
                            </Col>
                            {loaderDetailTraining && (
                              <Col sm="2">
                                <Spinner animation="border" size="sm" />
                              </Col>
                            )}
                          </Row>
                        </Form.Group>
                      </Row>
                    </Tab>

                    {(userRoles.length > 0 && userRoles.includes("jefe")) ||
                    userRoles.includes("administrador") ? (
                      <Tab eventKey="nota" title="Nota">
                        <Row>
                          <Form.Group as={Col}>
                            <Row className="align-items-end">
                              <Col sm={loaderDetailTraining ? "10" : "12"}>
                                <Form.Label className="ml-2">Nota</Form.Label>
                                <Form.Control
                                  id="calificacion"
                                  name="calificacion"
                                  isInvalid={
                                    touched.calificacion && errors.calificacion
                                  }
                                  isValid={
                                    touched.calificacion && !errors.calificacion
                                  }
                                  onBlur={handleBlur("calificacion")}
                                  onChange={handleChange}
                                  value={values.calificacion}
                                  className="rounded-pill"
                                  type="float"
                                  disabled={
                                    edit &&
                                    editItem.serializer_campania_capa[0].list_estado[0].descripcion.toLowerCase() ===
                                      "cerrado"
                                  }
                                  // placeholder="Estado"
                                ></Form.Control>
                                {!!errors.calificacion && (
                                  <div>
                                    <small className="text-danger">
                                      {errors.calificacion}
                                    </small>
                                  </div>
                                )}
                              </Col>
                              {loaderDetailTraining && (
                                <Col sm="2">
                                  <Spinner animation="border" size="sm" />
                                </Col>
                              )}
                            </Row>
                          </Form.Group>
                          <Form.Group as={Col}>
                            <Form.Label column>
                              Archivo de calificación
                            </Form.Label>

                            <Form.File
                              id="archivo"
                              name="archivo"
                              className="col position-relative my-2"
                              // disabled={!editItem.estado}
                              disabled={
                                edit &&
                                editItem.serializer_campania_capa[0].list_estado[0].descripcion.toLowerCase() ===
                                  "cerrado"
                              }
                              // value={values.archivo}
                              onChange={handleChange}
                              onBlur={handleBlur("archivo")}
                              isValid={touched.archivo && !errors.archivo}
                              isInvalid={touched.archivo && !!errors.archivo}
                              // disable={
                              //   employeeMonitor &&
                              //   employeeMonitor.estado[0].descripcion.toLowerCase() ===
                              //     "cerrado"
                              // }
                            />

                            {touched.archivo && errors.archivo && (
                              <Col>
                                <small className="text-danger">
                                  {errors.archivo}
                                </small>
                              </Col>
                            )}
                          </Form.Group>
                        </Row>
                        {editItem && editItem.archivo_id ? (
                          <>
                            <h6 className="text-muted ml-3">Archivo actual</h6>
                            <ul className="list-unstyled">
                              <LinkDescargaGD
                                id={editItem.id}
                                filters={{
                                  email: email,
                                  id: editItem.list_archivo[0].id_documento,
                                  llave: editItem.list_archivo[0].llave,
                                }}
                                origen={editItem.list_archivo[0].origen}
                                cType={editItem.list_archivo[0].contentTypeGD}
                              />
                            </ul>
                          </>
                        ) : null}
                      </Tab>
                    ) : null}
                  </Tabs>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderDetailTraining}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderDetailTraining && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default DetailTrainingMonitor;
